import HomeIcon from 'react-feather/dist/icons/home';

const menu = [{ label: 'Home', to: '/', icon: HomeIcon }];

export default menu;
